var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "fieldset",
      { staticClass: "pb-1 custom-fieldset" },
      [
        _c("v-divider"),
        _c(
          "v-row",
          { staticClass: "flight-divider" },
          [
            _c("v-col", { attrs: { cols: "4" } }, [
              _c("span", { staticClass: "white px-2" }, [
                _vm._v(_vm._s(_vm.contextAirlineName))
              ])
            ]),
            _c("v-spacer"),
            _c("v-col", { staticClass: "text-right", attrs: { cols: "1" } }, [
              _c("span", { staticClass: "white px-2" }, [
                _vm._v(_vm._s(_vm.flightTime))
              ])
            ])
          ],
          1
        ),
        _c(
          "v-row",
          {
            staticStyle: { position: "relative", top: "-10px" },
            attrs: { "no-gutters": "" }
          },
          [
            _c(
              "v-col",
              { staticClass: "px-3", attrs: { cols: "2" } },
              [
                _c("v-icon", { staticClass: "grey--text" }, [
                  _vm._v("flight_takeoff")
                ]),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.route.start_time.substr(0, 5)))
                ])
              ],
              1
            ),
            _c("v-col", { attrs: { cols: "2" } }, [
              _c("span", { staticClass: "grey--text" }, [
                _vm._v(
                  " " + _vm._s(_vm.formatDateView(_vm.route.start_date)) + " "
                )
              ])
            ]),
            _c("v-col", { attrs: { cols: "6" } }, [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(" " + _vm._s(_vm.route.start_place_name) + ", ")
              ]),
              _c("span", { staticClass: "accent--text font-weight-bold" }, [
                _vm._v(" " + _vm._s(_vm.route.start_airport_code) + " ")
              ]),
              _c("span", { staticClass: "grey--text" })
            ])
          ],
          1
        ),
        _c(
          "v-row",
          { staticClass: "my-2", attrs: { "no-gutters": "" } },
          [
            _c(
              "v-col",
              { staticClass: "px-3", attrs: { cols: "2" } },
              [
                _c("v-icon", { staticClass: "grey--text" }, [
                  _vm._v("flight_land")
                ]),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.route.end_time.substr(0, 5)))
                ])
              ],
              1
            ),
            _c("v-col", { attrs: { cols: "2" } }, [
              _c("span", { staticClass: "grey--text" }, [
                _vm._v(
                  " " + _vm._s(_vm.formatDateView(_vm.route.end_date)) + " "
                )
              ])
            ]),
            _c("v-col", { attrs: { cols: "6" } }, [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(" " + _vm._s(_vm.route.end_place_name) + ", ")
              ]),
              _c("span", { staticClass: "accent--text font-weight-bold" }, [
                _vm._v(" " + _vm._s(_vm.route.end_airport_code) + " ")
              ]),
              _c("span", { staticClass: "grey--text" })
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }